import Vue from "vue";
import axios from "axios"; // Lecture 346
import { FORM_TYPE } from "../constants/custom-define-type";
import {
  PARAM_REDIRECT_ON_USER_EXIST,
  PARAM_LOGIN,
  PARAM_HIDE_ERROR_MODAL
} from "../constants/url-params";

Vue.mixin({
  computed: {
    auth() {
      // Lecture 363
      //
      // Check if someone is logged in
      //
      return this.$store.getters.isAuthenticated;
    },
    isAdminOrEmployer() {
      return (
        this.$store.getters.isAgent === true ||
        this.$store.getters.isEmployer === true
      );
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
    async handleLogin(authData) {
      // Reset some lists (in case user login for user of another agency)
      this.$store.dispatch("setPriceList", null, { root: true });
      this.$store.dispatch("setAvailabilities", null, { root: true });
      this.$store.dispatch("setWeekAvailabilities", null, { root: true });
      this.$store.dispatch("setCandidateListMainInfo", null, { root: true });
      let hide_error = authData.hide_error ? true : false;
      const requestBody = {
        username: authData.email,
        password: authData.password,
        // agency: state.agencyID,
        agency: authData.agency,
        force: authData.force
      };
      let res = await axios
        .post(
          `/v1/api-token-auth/?${PARAM_LOGIN}&${PARAM_HIDE_ERROR_MODAL}=${hide_error}`,
          requestBody
        );
      
        if (res && res.data && res.data.user_list && res.data.user_list.length > 1) {
          const info = await this.showInputDialogSync({
            title: "Please select user type",
            listFields: [
              {
                label: "Please select which side do you want to use",
                type: FORM_TYPE.RADIO,
                optionList: ["Candidate", "Client"],
                model: "type"
              }
            ],
            submitLabel: "Login"
          });
          if (info && info.type) {
            requestBody.is_candidate = info.type === "Candidate";
            requestBody.is_employer = info.type === "Client";
            res = await axios
              .post(
                `/v1/api-token-auth/?${PARAM_LOGIN}&${PARAM_HIDE_ERROR_MODAL}=${hide_error}`,
                requestBody
              );
          }
        }

      if (!res) {
        return "failed";
      }

      if (res.response && res.response.status == 409) {
        return "multi-login";
      }

      // In case user just created, it response default agencyID, we need to load old agency
      let agencyID = res.data.agency_list[0].agency_id;
      const agencyName = res.data.agency_list[0].agency_name;
      if (agencyID === 1 && state.agencyID) {
        agencyID = state.agencyID;
      }
      this.$store.dispatch('saveAuthUser', {
        token: res.data.token,
        user_id: res.data.user_id,
        is_agent: res.data.is_agent,
        is_candidate: res.data.is_candidate,
        is_employer: res.data.is_employer,
        agency_id: agencyID,
        agency_name: agencyName,
        email: res.data.email,
        category: res.data.category
      })
      this.$store.dispatch("loadRecentAccessLog");

      if (res.data.agency_id != 1) {
        // The agency ID is 1 when doing the login on registration, because the agency ID hasn't been set yet
        this.$store.dispatch("increaseReloadAgencyReqNumber", 1); // Load agency data
      }
      return "success";
    },
    dashboardRedirect() {
      //
      // Redirect a logged in user to their appropriate dashboard page
      //
      if (this.$store.getters.isAgent) {
        const redirectObj = { name: "Agent Dashboard" };
        let defaultSelector = null;
        if (this.$store.getters.adminCategory == 'community') {
          defaultSelector = "Community";
        } else if (this.$store.getters.adminCategory == 'reference checker') {
          defaultSelector = "References"
        } else if (this.$store.getters.adminCategory == 'event manager') {
          defaultSelector = "Events"
        } else if (this.$store.getters.adminCategory == 'candidate supplier') {
          defaultSelector = "Candidates"
        } else if (this.$store.getters.adminCategory == 'client supplier') {
          defaultSelector = "Clients"
        }
        if (defaultSelector) {
          redirectObj.query = { selector: defaultSelector };
        }
        console.log(redirectObj);
        this.$router.replace(redirectObj);
      } else if (this.$store.getters.isCandidate) {
        this.$router.replace({ name: "Candidate Dashboard" });
      } else if (this.$store.getters.isEmployer) {
        this.$router.replace({ name: "Employer Dashboard" });
      }

    },
    // /* Check if the app is displayed inside an iframe or embed tag
    // https://stackoverflow.com/questions/326069/how-to-identify-if-a-webpage-is-being-loaded-inside-an-iframe-or-directly-into-t
    // */
    // isEmbed() {
    //   try {
    //     return window.self !== window.top;
    //   } catch (e) {
    //     return true;
    //   }
    // }
  }
});


// WEBPACK FOOTER //
// ./src/mixins/authen.js